// Audio chunks come from Gemini formatted as base64-encoded PCM16 little-endian chunks.
// This takes a chunk and converts it into a Float32Array, which is the format required
import airbrake from "src/airbrake-notifier"

// for local playback by the Web Audio API.
export function decodePcm16Chunk(base64: string): Float32Array | null {
  let binary: string
  try {
    binary = atob(base64)
  } catch (error) {
    airbrake.notify({
      message: "error decoding audio chunk from Gemini",
      params: { name: "decodePcm16Chunk" },
      error,
    })
    return null
  }
  const byteLen = binary.length
  if (byteLen < 2) return null
  const alignedLen = byteLen - (byteLen % 2)
  const bytes = new Uint8Array(alignedLen)
  for (let i = 0; i < alignedLen; i++) bytes[i] = binary.charCodeAt(i)
  const int16 = new Int16Array(bytes.buffer, bytes.byteOffset, alignedLen / 2)
  const float32 = new Float32Array(int16.length)
  for (let i = 0; i < int16.length; i++) float32[i] = int16[i] / 32768
  return float32
}
